import { render, staticRenderFns } from "./PageHeaderDesktop.vue?vue&type=template&id=7c1aa94a"
import script from "./PageHeaderDesktop.vue?vue&type=script&lang=js"
export * from "./PageHeaderDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports